import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Id_bs$SolvuuApi0 from "./id_bs.bs.js";
import * as S3_bs$SolvuuApi0 from "./s3_bs.bs.js";
import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Int64_wrap$SolvuuApi0 from "./int64_wrap.bs.js";
import * as Blob_event_bs$SolvuuApi0 from "./blob_event_bs.bs.js";

function write__1(param) {
  return Atdgen_codec_runtime.Encode.contramap(Int64_wrap$SolvuuApi0.unwrap, Atdgen_codec_runtime.Encode.string, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.map(Int64_wrap$SolvuuApi0.wrap, Atdgen_codec_runtime.Decode.string, param);
}

function write__2(param) {
  return Atdgen_codec_runtime.Encode.option_as_constr(Atdgen_codec_runtime.Encode.string, param);
}

var read__2 = Atdgen_codec_runtime.Decode.option_as_constr(Atdgen_codec_runtime.Decode.string);

function write__5(param) {
  return Atdgen_codec_runtime.Encode.option_as_constr(Blob_event_bs$SolvuuApi0.write_checksum, param);
}

var read__5 = Atdgen_codec_runtime.Decode.option_as_constr(Blob_event_bs$SolvuuApi0.read_checksum);

function write__4(param) {
  return Atdgen_codec_runtime.Encode.option_as_constr(write__1, param);
}

var read__4 = Atdgen_codec_runtime.Decode.option_as_constr(read__1);

function write__6(param) {
  return Atdgen_codec_runtime.Encode.list(Blob_event_bs$SolvuuApi0.write_processor_job, param);
}

function read__6(param) {
  return Atdgen_codec_runtime.Decode.list(Blob_event_bs$SolvuuApi0.read_processor_job, param);
}

function write__3(param) {
  return Atdgen_codec_runtime.Encode.option_as_constr(Blob_event_bs$SolvuuApi0.write_storage, param);
}

var read__3 = Atdgen_codec_runtime.Decode.option_as_constr(Blob_event_bs$SolvuuApi0.read_storage);
var write_available = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__2, "source", t.source),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Blob_event_bs$SolvuuApi0.write_storage, "storage", t.storage),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__4, "size_claimed", t.size_claimed),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__4, "size", t.size),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__5, "checksum_claimed", t.checksum_claimed),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__5, "checksum", t.checksum),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__6, "processor_jobs", t.processor_jobs),
  /* [] */
  0]]]]]]]);
});
var read_available = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    source: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("source", read__2, param);
    }, json),
    storage: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("storage", Blob_event_bs$SolvuuApi0.read_storage, param);
    }, json),
    size_claimed: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("size_claimed", read__4, param);
    }, json),
    size: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("size", read__4, param);
    }, json),
    checksum_claimed: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("checksum_claimed", read__5, param);
    }, json),
    checksum: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("checksum", read__5, param);
    }, json),
    processor_jobs: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("processor_jobs", read__6, param);
    }, json)
  };
});
var write_created = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__2, "source", t.source),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__3, "storage", t.storage),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__4, "size_claimed", t.size_claimed),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__5, "checksum_claimed", t.checksum_claimed),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__6, "processor_jobs", t.processor_jobs),
  /* [] */
  0]]]]]);
});
var read_created = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    source: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("source", read__2, param);
    }, json),
    storage: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("storage", read__3, param);
    }, json),
    size_claimed: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("size_claimed", read__4, param);
    }, json),
    checksum_claimed: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("checksum_claimed", read__5, param);
    }, json),
    processor_jobs: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("processor_jobs", read__6, param);
    }, json)
  };
});
var write_started = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__2, "source", t.source),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Blob_event_bs$SolvuuApi0.write_storage, "storage", t.storage),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.$$int, "num_parts_received", t.num_parts_received),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__1, "bytes_received", t.bytes_received),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__4, "size_claimed", t.size_claimed),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__5, "checksum_claimed", t.checksum_claimed),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__6, "processor_jobs", t.processor_jobs),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.string, "upload_id", t.upload_id),
  /* [] */
  0]]]]]]]]);
});
var read_started = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    source: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("source", read__2, param);
    }, json),
    storage: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("storage", Blob_event_bs$SolvuuApi0.read_storage, param);
    }, json),
    num_parts_received: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("num_parts_received", Atdgen_codec_runtime.Decode.$$int, param);
    }, json),
    bytes_received: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("bytes_received", read__1, param);
    }, json),
    size_claimed: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("size_claimed", read__4, param);
    }, json),
    checksum_claimed: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("checksum_claimed", read__5, param);
    }, json),
    processor_jobs: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("processor_jobs", read__6, param);
    }, json),
    upload_id: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("upload_id", Atdgen_codec_runtime.Decode.string, param);
    }, json)
  };
});
var write_validated = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__2, "source", t.source),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Blob_event_bs$SolvuuApi0.write_storage, "storage", t.storage),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__1, "size", t.size),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Blob_event_bs$SolvuuApi0.write_checksum, "checksum", t.checksum),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__6, "processor_jobs", t.processor_jobs),
  /* [] */
  0]]]]]);
});
var read_validated = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    source: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("source", read__2, param);
    }, json),
    storage: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("storage", Blob_event_bs$SolvuuApi0.read_storage, param);
    }, json),
    size: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("size", read__1, param);
    }, json),
    checksum: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("checksum", Blob_event_bs$SolvuuApi0.read_checksum, param);
    }, json),
    processor_jobs: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("processor_jobs", read__6, param);
    }, json)
  };
});
var write_completed = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x[0] >= 425081257) {
    return Atdgen_codec_runtime.Encode.constr1("Available", write_available, x[1]);
  } else {
    return Atdgen_codec_runtime.Encode.constr1("Validated", write_validated, x[1]);
  }
});
var read_completed = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Available",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Available */
      [425081257, x]
    );
  }, read_available, param);
}]],
/* :: */
[
/* tuple */
["Validated",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Validated */
      [-465202450, x]
    );
  }, read_validated, param);
}]],
/* [] */
0]]);

function write_corrupt(js) {
  return Curry._1(Atdgen_codec_runtime.Encode.make(function (t) {
    return Atdgen_codec_runtime.Encode.obj(
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.string, "event_id_which_caused_corruption", t.event_id_which_caused_corruption),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, write_state, "last_known_good_state", t.last_known_good_state),
    /* [] */
    0]]);
  }), js);
}

function write_failed(js) {
  return Curry._1(Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Corrupt", write_corrupt, x[1]);
  }), js);
}

function write_state(js) {
  return Curry._1(Atdgen_codec_runtime.Encode.make(function (x) {
    var variant = x[0];

    if (variant >= 40653089) {
      if (variant >= 479410653) {
        return Atdgen_codec_runtime.Encode.constr1("Failed", write_failed, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Started", write_started, x[1]);
      }
    } else if (variant >= -250904213) {
      return Atdgen_codec_runtime.Encode.constr1("Completed", write_completed, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Created", write_created, x[1]);
    }
  }), js);
}

function read_corrupt(js) {
  return Curry._1(Atdgen_codec_runtime.Decode.make(function (json) {
    return {
      event_id_which_caused_corruption: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("event_id_which_caused_corruption", Atdgen_codec_runtime.Decode.string, param);
      }, json),
      last_known_good_state: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("last_known_good_state", read_state, param);
      }, json)
    };
  }), js);
}

function read_failed(js) {
  return Curry._1(Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Corrupt",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Corrupt */
        [857522093, x]
      );
    }, read_corrupt, param);
  }]],
  /* [] */
  0]), js);
}

function read_state(js) {
  return Curry._1(Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Created",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Created */
        [-558113336, x]
      );
    }, read_created, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Started",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Started */
        [40653089, x]
      );
    }, read_started, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Failed",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Failed */
        [479410653, x]
      );
    }, read_failed, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Completed",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Completed */
        [-250904213, x]
      );
    }, read_completed, param);
  }]],
  /* [] */
  0]]]]), js);
}

var write_t = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Id_bs$SolvuuApi0.write_blob, "id", t.id),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write_state, "state", t.state),
  /* [] */
  0]]);
});
var read_t = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    id: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("id", Id_bs$SolvuuApi0.read_blob, param);
    }, json),
    state: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("state", read_state, param);
    }, json)
  };
});
var write_s3_upload = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, S3_bs$SolvuuApi0.write_instructions, "instructions", t.instructions),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__2, "upload_id", t.upload_id),
  /* [] */
  0]]);
});
var read_s3_upload = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    instructions: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("instructions", S3_bs$SolvuuApi0.read_instructions, param);
    }, json),
    upload_id: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("upload_id", read__2, param);
    }, json)
  };
});
var write_instructions = Atdgen_codec_runtime.Encode.make(function (x) {
  return Atdgen_codec_runtime.Encode.constr1("S3", Atdgen_codec_runtime.Encode.make(function (x) {
    if (x[0] >= -344447064) {
      return Atdgen_codec_runtime.Encode.constr1("Download", S3_bs$SolvuuApi0.write_instructions, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Upload", write_s3_upload, x[1]);
    }
  }), x[1]);
});
var partial_arg = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Download",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Download */
      [-344447064, x]
    );
  }, S3_bs$SolvuuApi0.read_instructions, param);
}]],
/* :: */
[
/* tuple */
["Upload",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Upload */
      [-1058128351, x]
    );
  }, read_s3_upload, param);
}]],
/* [] */
0]]);
var read_instructions = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["S3",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `S3 */
      [18560, x]
    );
  }, partial_arg, param);
}]],
/* [] */
0]);
var write_denied_reason = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x !== -123472819) {
    if (x >= 425081257) {
      return Atdgen_codec_runtime.Encode.constr0("Available");
    } else {
      return Atdgen_codec_runtime.Encode.constr0("Unavailable");
    }
  } else {
    return Atdgen_codec_runtime.Encode.constr0("Server_side_upload");
  }
});
var read_denied_reason = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Available",
/* `Single */
[-306849112,
/* Available */
425081257]],
/* :: */
[
/* tuple */
["Unavailable",
/* `Single */
[-306849112,
/* Unavailable */
-514033616]],
/* :: */
[
/* tuple */
["Server_side_upload",
/* `Single */
[-306849112,
/* Server_side_upload */
-123472819]],
/* [] */
0]]]);
var read_checksum = Blob_event_bs$SolvuuApi0.read_checksum;
var write_checksum = Blob_event_bs$SolvuuApi0.write_checksum;
var read_int64 = read__1;
var write_int64 = write__1;
var read_processor_job = Blob_event_bs$SolvuuApi0.read_processor_job;
var write_processor_job = Blob_event_bs$SolvuuApi0.write_processor_job;
var read_storage = Blob_event_bs$SolvuuApi0.read_storage;
var write_storage = Blob_event_bs$SolvuuApi0.write_storage;
var read_id = Id_bs$SolvuuApi0.read_blob;
var write_id = Id_bs$SolvuuApi0.write_blob;
var read_s3_instructions = S3_bs$SolvuuApi0.read_instructions;
var write_s3_instructions = S3_bs$SolvuuApi0.write_instructions;
var read_s3_download = S3_bs$SolvuuApi0.read_instructions;
var write_s3_download = S3_bs$SolvuuApi0.write_instructions;
var read_event_id = Id_bs$SolvuuApi0.read_event;
var write_event_id = Id_bs$SolvuuApi0.write_event;
export { read_checksum, write_checksum, read_int64, write_int64, read_processor_job, write_processor_job, read_storage, write_storage, read_available, write_available, read_created, write_created, read_started, write_started, read_validated, write_validated, read_completed, write_completed, read_corrupt, write_corrupt, read_failed, write_failed, read_state, write_state, read_id, write_id, read_t, write_t, read_s3_instructions, write_s3_instructions, read_s3_upload, write_s3_upload, read_s3_download, write_s3_download, read_instructions, write_instructions, read_event_id, write_event_id, read_denied_reason, write_denied_reason };
/* read__2 Not a pure module */